<template>
    <div class="DashboardLayout" v-if="UserPrivateProfile.UserId">
        <div>
            <nav class="navbar navbar-light navbar-expand-md navigation-clean">
                <div class="container-fluid">
                    <a id="navbar-brand" class="navbar-brand pointer"><img v-bind:src="sitelogo" /></a><button data-toggle="collapse" class="navbar-toggler" data-target="#navcol-1"><span class="sr-only">Toggle navigation</span><span class="navbar-toggler-icon"></span></button>
                    <div class="collapse navbar-collapse"
                         id="navcol-1">
                        <b-nav pills class="ml-auto" style="margin-right:50px;">
                            <b-nav-item class="hidden" role="presentation"></b-nav-item>
                            <!--<b-nav-item v-on:click="ChangePaneShown('UserDashboard')" v-bind:class="{ active: PanesShown.UserDashboard }"><font-awesome-icon :icon="['fa', 'users']" /> Users</b-nav-item>-->
                            <!--<b-nav-item v-on:click="ChangePaneShown('FosterDashboard')" v-bind:class="{ active: PanesShown.FosterDashboard }"><font-awesome-icon :icon="['fa', 'home']" /> Foster</b-nav-item>
    <b-nav-item v-on:click="ChangePaneShown('BillingDashboard')" v-bind:class="{ active: PanesShown.BillingDashboard }"><font-awesome-icon :icon="['fa', 'home']" /> Billing</b-nav-item>-->
                            <b-nav-item v-on:click="ChangePaneShown('CensusDashboard')" v-bind:class="{ active: PaneShown == 'CensusDashboard' }"><font-awesome-icon :icon="['fa', 'users']" /> Census</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('FosterDashboard')" v-bind:class="{ active: PaneShown == 'FosterDashboard' }"><font-awesome-icon :icon="['fa', 'home']" /> Foster</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('ScorecardDashboard')" v-bind:class="{ active: PaneShown == 'ScorecardDashboard' }"><font-awesome-icon :icon="['fa', 'home']" /> Scorecard</b-nav-item>
                            <!--<b-nav-item v-on:click="ChangePaneShown('FamiliesPaneShown')" v-bind:class="{ active: PanesShown.FamiliesPaneShown }"><font-awesome-icon :icon="['fa', 'home']" /> Families</b-nav-item>-->
                            <!--<b-nav-item v-on:click="ChangePaneShown('UsersettingsPaneShown')" v-bind:class="{ active: PanesShown.UsersettingsPaneShown }"><font-awesome-icon :icon="['fa', 'toolbox']" /> Settings</b-nav-item>-->
                            <!--<b-nav-item v-on:click="ChangePaneShown('DocumentsPaneShown')" v-bind:class="{ active: PanesShown.DocumentsPaneShown }"><font-awesome-icon :icon="['fa', 'file-alt']" /> Documents</b-nav-item>-->
                            <b-nav-item><Logout /></b-nav-item>
                        </b-nav>
                    </div>
                </div>
            </nav>
        </div>

        <div class="tab-content col-12 padding-adjust-for-overlay-scroll">
            <div class="tab-pane fade active show" role="tabpanel" id="tab-home">
                <div id="FosterHomeTab">

                </div>
            </div>
            <div v-if="PaneShown == 'CensusDashboard'">
                <CensusDashboardPane />
            </div>
            <div v-if="PaneShown == 'FosterDashboard'">
                <FosterDashboardPane />
            </div>
            <div v-if="PaneShown == 'ScorecardDashboard'">
                <ScorecardDashboardPane />
            </div>

        </div>
        <!--Logged in User-->
        <p class="upper-right" v-if="UserPrivateProfile.FirstName">Logged in as: {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</p>
    </div>
</template>

<script>
    //import services
    import { UserAPI } from '../../../services/api/Core/UserAPI.js';
    //import components

    import ScorecardDashboardPane from '../ScorecardDashboard/ScorecardDashboardPane.vue';
    import CensusDashboardPane from '../CensusDashboard/CensusDashboardPane.vue';
    import FosterDashboardPane from '../FosterDashboard/FosterDashboardPane.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faUsers } from '@fortawesome/free-solid-svg-icons';
    library.add(faUsers);
    import { faHome } from '@fortawesome/free-solid-svg-icons';
    library.add(faHome);
    
    
    export default {
        name: "DashboardLayout",
        created() {
            const userAPI = new UserAPI(this.$baseURL);
            this.userAPI = userAPI;
            this.$store.commit("User.PrivateProfile.Clear");
        },
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_Banner_Dashboard.png",
                PaneShown: "CensusDashboard"
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            GetEmployeePrivateProfile() {
                let vm = this;
                vm.$store.commit("UI.BumpLoadsInProgress", 1);
                this.userAPI.GetEmployeePrivateProfile().then((data) => {
                    vm.$store.commit("UI.BumpLoadsInProgress", -1);
                    data.data.AssignedSubPrograms = data.data.AssignedSubPrograms.filter(sp => sp.HasClients);
                    this.$store.commit("User.PrivateProfile.Replace", data.data);
                });
            }
        },
        components: {
            ScorecardDashboardPane,
            CensusDashboardPane,
            FosterDashboardPane
        },
        mounted() {
            this.GetEmployeePrivateProfile();
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            }
        }
    }
</script>

<style scoped>
    .upper-right {
        position:absolute;
        top:0;
        right:40px;
    }

    .DashboardLayout {
        background-color: #605271;
    }
</style>